export enum BuildMode {
  lib = 'lib',
  web = 'web'
}
